import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  card: {
    margin: `${theme.spacing(3)} 0`
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0rem 1rem',
    minHeight: '3rem'
  },
  checkbox: {
    padding: theme.spacing(1)
  },
  emailTemplateCardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0rem 1rem',
    minHeight: '3rem',
    '& > .MuiCardHeader-content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  },
  formControl: {
    margin: `${theme.spacing(1)} 0`,
    width: '25%'
  },
  linkText: {
    color: theme.vars.palette.primary.main,
    textDecoration: 'none'
  },
  newTicketTemplate: {
    backgroundColor: theme.vars.palette.background.elevation0,
    borderRadius: 4,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2)
  },
  newTicketTemplateItem: {
    padding: theme.spacing(0.5)
  },
  responsePlanCard: {
    padding: '0 !important'
  },
  responsePlanTable: {
    border: 'none',
    '& .MuiDataGrid-cell': {
      paddingLeft: theme.spacing(3)
    },
    '& .MuiDataGrid-columnHeader': {
      paddingLeft: theme.spacing(3)
    },
    '& .MuiDataGrid-row--editing': {
      '& .MuiDataGrid-cell': {
        paddingLeft: theme.spacing(3),
        backgroundColor: theme.vars.palette.background.elevation0
      }
    }
  },
  slider: {
    alignSelf: 'center',
    width: '97%'
  },
  sliderCardContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  subText: {
    color: theme.vars.palette.text.secondary
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2)
  }
}));

export default useStyles;
